import {
  Box,
  LinearProgress,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

interface KbImportProgressStateProps {
  fileCount: number;
  progress: number; // 0-100
  uploadedBytes: number;
  totalBytes: number;
}

const formatBytes = (bytes: number): string => {
  if (bytes === 0) return "0";
  const kb = bytes / 1024;
  return `${Math.round(kb)}`;
};

export const KbImportProgressState = ({
  fileCount,
  progress,
  uploadedBytes,
  totalBytes,
}: KbImportProgressStateProps) => {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        padding: "24px",
        gap: "16px",
      }}
    >
      <Stack
        sx={{
          gap: "8px",
          width: "100%",
        }}
      >
        <Typography
          variant="body-medium"
          sx={{
            color: theme.palette.lightBg.low,
          }}
        >
          Uploading {fileCount} file{fileCount !== 1 ? "s" : ""}
        </Typography>
      </Stack>

      <Stack
        sx={{
          width: "100%",
          gap: "8px",
        }}
      >
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: "6px",
            borderRadius: "4px",
            backgroundColor: theme.palette.neutral["015"],
            "& .MuiLinearProgress-bar": {
              borderRadius: "4px",
              backgroundColor: theme.palette.success.main,
            },
          }}
        />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="caption-3"
            sx={{
              color: theme.palette.lightBg.low,
            }}
          >
            {Math.round(progress)}% uploaded
          </Typography>
          <Typography
            variant="caption-3"
            sx={{
              color: theme.palette.lightBg.low,
            }}
          >
            {formatBytes(uploadedBytes)} of {formatBytes(totalBytes)} kb
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
